export default __webpack_public_path__ + "static/optimizationImg-b9cafe76a3000aeb208c4134cb09d42b.svg";